import { AUTH_API_BASE_URL, urlFor, request } from '../index'

export async function getCommissionMemberHistoryReport(text) {
  try {
    return request('get', urlFor(AUTH_API_BASE_URL, `/commission-member/history?${text}`), {
      auth: true,
    })
  } catch (e) {
    return e
  }
}

export async function getAllCommissionRole() {
  try {
    return request('get', urlFor(AUTH_API_BASE_URL, `/commission-member/all`), {
      auth: true,
    })
  } catch (e) {
    return e
  }
}

export async function getCommissionRoleById(text) {
  try {
    return request('get', urlFor(AUTH_API_BASE_URL, `/commission-member/${text}`), {
      auth: true,
    })
  } catch (e) {
    return e
  }
}

export async function updateCommissionRoleById(data) {
  try {
    return request('patch', urlFor(AUTH_API_BASE_URL, `/commission-member/update/id`), {
      auth: true,
      data: data,
    })
  } catch (e) {
    return e
  }
}

export async function addNewCommissionRole(data) {
  try {
    return request('post', urlFor(AUTH_API_BASE_URL, `/commission-member/add`), {
      auth: true,
      data: data,
    })
  } catch (e) {
    return e
  }
}
